<template>
  <div class="mutilFileBox" style="margin-top: 10px;overflow: auto;">
    <div class="unitTitle">
      <div style="margin-left: 110px;">{{ fileData.name }}</div>
      <div style="flex: 1;"></div>
      <div style="margin-right: 10px;color: #2D53ED;font-size: 12px;cursor:pointer;"  @click="delCompany">
        <i class="el-icon-delete" style="margin-right: 5px;"></i>删除</div>
    </div>
    <div style="flex:1;height: 1px;overflow:auto;">
        <div v-for="(item, idx) in fileData.fileList" :key="idx" class="file_box">
          <img v-if="ext == '.docx'" src="@/assets/image/word.png" width="40px" height="40px" alt="">
          <img v-if="ext == '.pdf'" src="@/assets/image/pdf.png" width="40px" height="40px" alt="">

          <div class="fileName">{{ item.name }}</div>
          <div style="flex: 1;"></div>
          <i
              class="el-icon-remove-outline"
              @click="del_file(item)"
              style="line-height: 30px; margin-left: 16px; cursor: pointer"
          ></i>
        </div>
    </div>
    <div style="height: 30px;border-top:1px solid #ddd; text-align: center;">
      <el-upload
          action=""
          :multiple="true"
          :show-file-list="false"
          :file-list="fileList"
          :on-change="change"
          :on-remove="remove"
          :auto-upload="false"
          :accept="ext"
          ref="upload"
      >
        <i class="el-icon-circle-plus-outline"></i>
        <span style="font-size: 12px;line-height: 30px;margin-left: 5px;">新增文件</span>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  name: "mutilFile",
  props: {
    ext:{
      type:String,
      required:true
    },
    fileData: {
      type: Object,
      required: true,
    },
    alltb: {
      type: Array,
      required: true,
    },
    allzb: {
      type: Array,
      required: true,
    },
  },
  data(){
    return {
      companyName: "",
      fileList: [],
    };
  },
  created() {
    this.companyName = this.fileData.name;
    this.fileList = this.fileData.fileList;
  },
  methods: {
    change(file, fileList) {
      //检查文件格式
      if (!this.$util.checkFileExt(file, this.extList)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["upload"].handleRemove(file);
        this.fileList = fileList;
        return;
      }

      //检查文件数量
      if (!this.$util.checkAllFileNums([...fileList], 5)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["upload"].handleRemove(file);
        this.fileList = fileList;
        return;
      }
      //检查文件大小
      if (!this.$util.checkAllFileSize([...fileList], 1000)) {
        fileList = this.$_.reject(fileList, (item) => {
          return file == item;
        });
        this.$refs["upload"].handleRemove(file);
        this.fileList = fileList;
        return;
      }
      this.fileList = fileList;
      this.$emit("change", this.fileList, this.fileData.idx);
      // const self = this;
      // const fileReader = new FileReader();
      // const dataFile = file.raw;
      // fileReader.readAsArrayBuffer(dataFile);
      // fileReader.onload = function (e) {
      //   const hash = self.$md5.create();
      //   hash.update(e.target.result);
      //   file["contentMd5"] = hash.base64();
      //   self.fileList = fileList;
      //   self.$emit("change", self.fileList, self.fileData.idx);
      // };
    },
    remove(file, fileList) {
      this.fileList = fileList;
      this.$emit("change", this.fileList, this.fileData.idx);
    },
    del_file(item) {
      this.$refs["upload"].handleRemove(item);
    },
    delCompany() {
      this.$emit("delCompany", this.fileData.idx);
    },
  },
  computed: {
    allList() {
      let temp = this.allzb.concat(this.alltb);
      return temp;
    },
    extList(){
      let arr = this.ext.split(".");
      return [arr[1]]
    }
  },
}
</script>

<style scoped lang="scss">
.mutilFileBox{
  display: flex;
  flex-direction: column;
  width: 275px;
  height: 300px;
  background-color: #FFFFFF;
  border-radius: 0px;
  background-image: url("~@/assets/image/unitBox.png");
  background-repeat: no-repeat;
  margin-right: 10px;
  .unitTitle{
    line-height: 32px;
    color: #889ABD;
    font-size: 14px;
    display: flex;
  }
}
.file_box{
  display: flex;
  height: 40px;
  padding: 0 5px 0 5px;
  margin-top: 5px;
}
.fileName{
  height: 40px;
  line-height: 40px;
  display: -webkit-box; /*  display: -webkit-box; 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示  */
  -webkit-box-orient: vertical; /*  -webkit-box-orient 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式  */
  -webkit-line-clamp: 1; /*  -webkit-line-clamp用来限制在一个块元素显示的文本的行数 */
  overflow: hidden;
  font-size: 12px;
  text-align: center;
}
</style>
